import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Check2 } from 'react-bootstrap-icons';
import AccountInfo from './components/AccountInfo';
import BranchInfo from './components/BranchInfo';
import PersonalDetails from './components/PersonalDetails';
import UserRoles from './components/UserRoles';

const UserProfile = () => {
    return (
        <div className="py-3 min-vh-100">
            <Container>
                {/* Header Section */}
                <Row className="mb-3 align-items-center">
                    <Col>
                        <h4 className="fw-bold text-900 mb-0 fs-8">User Profile</h4>
                        <p className="text-600 mb-0 fs-11">Manage your personal information, credentials, and security preferences.</p>
                    </Col>
                    <Col xs="auto">
                        <Button variant="primary" className="px-3 py-1 fw-medium rounded-2 d-flex align-items-center gap-1 fs-11">
                            <Check2 size={16} />
                            Save Changes
                        </Button>
                    </Col>
                </Row>

                {/* Main Content Sections - Stacked Categories */}
                <Row className="g-3">
                    <Col xs={12}>
                        <AccountInfo />
                    </Col>

                    <Col xs={12}>
                        <BranchInfo />
                    </Col>



                    <Col xs={12}>
                        <UserRoles />
                    </Col>
                </Row>
            </Container>

            <style dangerouslySetInnerHTML={{
                __html: `
                
            
            `}} />
        </div>
    );
};

export default UserProfile;
